export default __webpack_public_path__ + "static/Grocers-Script-Regular-710ad72342af92b9f6278b83e4f98ed3.ttf";